import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid2";
import {
  useTheme,
  useMediaQuery,
  Dialog,
  DialogContent,
  IconButton,
  Divider,
  Backdrop,
} from "@mui/material";
import { initialHelperFunction, useAuth } from "../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import chennaiIcon from "../../assets/images/chennai.png";
import maduraiIcon from "../../assets/images/madurai.png";
import thirunelveliIcon from "../../assets/images/thirunelveli.png";
import nagarcoilIcon from "../../assets/images/nagarcoil.png";
import bangaloreIcon from "../../assets/images/bangalore.png";
import sivakasiIcon from "../../assets/images/sivakasi.png";
import TamilnaduIcon from "../../assets/images/TamilNadu.png";
import usilampattiIcon from "../../assets/images/Usilampatti_.png";
import { X } from "@phosphor-icons/react";
import { is } from "date-fns/locale";
import { useEffect } from "react";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15, // delay between each item
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: "easeOut" },
  },
};
const MotionGrid = motion(Grid);
const MotionBox = motion(Box);
export default function RegionDialog({ toggleRegionModal, open, data }) {
  const { user, setUser, helperFunction, setHelperFunction } = useAuth();
  const selectedRegionId = user?.region_id;
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const regionIcon = (region) => {
    switch (region) {
      case "Bengaluru":
        return bangaloreIcon;
      case "Chennai":
        return chennaiIcon;
      case "Madurai":
        return maduraiIcon;
      case "Tirunelveli":
        return thirunelveliIcon;
      case "Nagercoil":
        return nagarcoilIcon;
      case "Sivakasi":
        return sivakasiIcon;
      case "Usilampatti":
        return usilampattiIcon;
      case "Tamil Nadu":
        return TamilnaduIcon;
      default:
        return null;
    }
  };

  const regionHandler = (item) => {
    const hasRegionChanged = user?.region_id !== item?.region_id;

    setUser((prev) => ({
      ...prev,
      region_id: item?.region_id,
      region_name: item?.city?.name,
    }));

    toggleRegionModal();

    if (hasRegionChanged) {
      const shouldRedirect = [
        "/product-description/",
        "/listing/",
        // "/cart",
        // "/checkout",
      ].some((path) => location.pathname.startsWith(path));
      if (shouldRedirect) navigate("/");
    }
    if (helperFunction?.exeFunction && helperFunction?.to === "CART") {
      helperFunction?.exeFunction();
      setHelperFunction(initialHelperFunction);
    }
  };
  // useEffect(() => {
  //   if ((data?.length > 0 && user?.region_id == null, isMobile)) {
  //     setTimeout(() => {
  //       toggleRegionModal();
  //     }, 4000);
  //   }
  // }, [data, user?.region_id, setUser]);
  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={open}
      transitionDuration={500}
    >
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            toggleRegionModal();
          }
        }}
        disableEscapeKeyDown
        disableBackdropClick
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            mx: isMobile ? 0 : 4,
            borderRadius: isMobile ? 0 : "12px",
          },
        }}
      >
        <DialogContent sx={{ padding: isMobile ? "16px" : "24px" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: isMobile ? "18px" : "20px",
                fontWeight: 600,
                lineHeight: "150%",
                color: "var(--neutral-black)",
                textAlign: isMobile ? "center" : "left",
                margin: "auto",
                marginLeft: isMobile ? 0 : "auto",
              }}
            >
              Select City
            </Typography>
            <IconButton
              aria-label="close"
              size="small"
              onClick={toggleRegionModal}
              sx={{ px: 1, display: selectedRegionId ? "block" : "none" }}
            >
              <X size={24} />
            </IconButton>
          </Box>
          <Divider sx={{ my: 2, mb: 3 }} />

          <MotionGrid
            container
            spacing={{ xs: 2, sm: 3 }}
            justifyContent="center"
            alignItems="center"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {data?.map((item, index) => (
              <Grid
                size={{ xs: 12, sm: 6, md: 4 }}
                key={index}
                display="flex"
                justifyContent="center"
              >
                <MotionBox
                  variants={itemVariants}
                  onClick={() => regionHandler(item)}
                  sx={{
                    width: "100%",
                    maxWidth: isMobile ? "85%" : "250px",
                    border:
                      selectedRegionId === item?.region_id
                        ? "1px solid var(--primary-red-base)"
                        : "1px solid var(--neutral-300)",
                    borderRadius: "8px",
                    background:
                      selectedRegionId === item?.region_id &&
                      "var(--primary-red-100)",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    cursor: "pointer",
                    p: 1,
                    ":hover": {
                      border: "1px solid var(--primary-red-base)",
                      scale: 1.02,
                      transition: "all 0.25s ease-in-out",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={regionIcon(item?.city?.name)}
                    alt={item?.city?.name}
                    sx={{
                      height: { xs: "60px", md: "100px" },
                      width: "auto",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      fontWeight:
                        selectedRegionId === item?.region_id ? 700 : 600,
                      color:
                        selectedRegionId === item?.region_id
                          ? "var(--neutral-900)"
                          : "var(--neutral-800)",
                      textAlign: "center",
                    }}
                  >
                    {item?.city?.name}
                  </Typography>
                </MotionBox>
              </Grid>
            ))}
          </MotionGrid>
        </DialogContent>
      </Dialog>
    </Backdrop>
  );
}
